import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Post() {
  const btnWrap = document.querySelector('.p-archive__btn');
  const btn = document.querySelector('.js-post');
  const lists = Array.from(document.querySelectorAll('.c-archive01__item'));
  if (!btnWrap || !btn || lists.length === 0) return;

  const perPage = 5;
  let currentIndex = 0;

  if (lists.length <= perPage) {
    btnWrap.style.display = 'none';
  }

  // 最初にすべて非表示にして、先頭5件だけ表示
  lists.forEach((el, index) => {
    el.style.display = index < perPage ? '' : 'none';
  });
  currentIndex = perPage;

  // ボタンクリックで次の5件を表示
  btn.addEventListener('click', () => {
    const nextIndex = currentIndex + perPage;

    lists.slice(currentIndex, nextIndex).forEach((el) => {
      el.style.display = '';
    });

    currentIndex = nextIndex;

    if (typeof ScrollTrigger !== 'undefined') {
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
      });
    }

    // 全部表示し終えたらボタンを非表示
    if (currentIndex >= lists.length) {
      btnWrap.style.display = 'none';
    }
  });
}

export { Post };
